import * as React from 'react'
import { isBoolean } from 'lodash'


export default function ({children}){
        return (
            <div className="alert alert-danger alert-dismissable" >
                {children}
            </div>
        )
} 